export default __webpack_public_path__ + "static/media/manchester-logo.332faeff.png";